import {
    Product,
    Ticket,
} from "../../../main/content/app/product/product.model";
import { Category } from "../categories/category.model";
import { UserProfile } from "../users/profile.model";
import { Voucher } from "../vouchers/voucher.model";

export class OrderItemDto {
    product: string;
    ticket: string;
    title: string;
    title_en: string;
    date: Date;
    time?: string;
    duration?: string;
    embarcadere?: string;
    price: number;
    priceDiscount: number;
    vatRate: number;
    quantity: number;
    boarded: number;
    amountVat10: number;
    amountVat20: number;
    vat10: number;
    vat20: number;
}

export class OrderCreateDto {
    user: string;
    discount: boolean;
    category: string;
    type: string;
    direction?: string;
    comment?: string;
    items: OrderItemDto[];
    voucherCode?: string;
}

export abstract class OrderItemResult {
    _id?: string;
    product: string | Product;
    ticket: string | Ticket;
    title: string;
    title_en: string;
    date: Date;
    time?: string;
    duration?: string;
    embarcadere?: string;
    price: number;
    priceDiscount?: number;
    vatRate: number;
    quantity: number;
    boarded: number;
    amount: number;
    amountVAT: number;
    amountTotal: number;
}

export abstract class OrderStatusHistoryResult {
    status: string;
    date: Date;
}

export abstract class OrderResult {
    _id: string;
    user: UserProfile;
    category: Category;
    voucher: Voucher;
    type: string;
    direction?: string;
    comment?: string;

    status: string;
    statusesHistory: OrderStatusHistoryResult[];
    items: OrderItemResult[];

    amount: number;
    amountVAT: number;
    amountTotal: number;
    quantityTotal: number;
    qrcodeToken: string;
    invoiceNum?: number;
    discount: boolean;

    createdAt: Date;
    updatedAt: Date;
    validatedAt?: Date;
    amountVat10: number;
    amountVat20: number;
}

export interface OrderAdminListQuery {
    status?: string;
    from?: Date;
    to?: Date;
    operator?: string;
    category?: string;
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
}

export interface OrdersPageResult {
    items: OrderResult[];
    total: number;
    page: number;
    limit: number;
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/orders/order.models.ts